import Vue from 'vue'
import Router from 'vue-router'

import home from '@/page/home/index.vue'
import admin from '@/page/module/admin/login.vue'
import adminhome from '@/page/module/admin/home.vue'
import adminindex from '@/page/module/admin/index.vue'
import login from '@/page/module/login/login.vue'
import index from '@/page/index.vue'
import lookfrom from '@/page/module/util/lookfrom'

Vue.use(Router)
export default new Router({
  mode: 'hash',
  routes: [
    {path: '/', name: 'home', component: home},
    {path: '/admin', name: 'admin', component: admin},
    {path: '/adminlogin', name: 'adminlogin', component: admin},
    {path: '/adminindex', name: 'adminindex', component: adminindex},
    {path: '/adminhome', name: 'adminhome', component: adminhome},
    {path: '/login', name: 'login', component: login},
    {path: '/index', name: 'index', component: index},
    {path: '/lookfrom', name: 'lookfrom', component: lookfrom},
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js